import { render, staticRenderFns } from "./InvalidWebshopView.vue?vue&type=template&id=f997b328"
import script from "./InvalidWebshopView.vue?vue&type=script&lang=ts"
export * from "./InvalidWebshopView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports